import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  HostListener,
  ElementRef,
} from "@angular/core";

@Component({
  selector: "app-multi-select-dropdown",
  templateUrl: "./multi-select-dropdown.component.html",
  styleUrls: ["./multi-select-dropdown.component.css"],
})
export class MultiSelectDropdownComponent implements OnInit {
  loading = false;
  @Input() itemList: any[] = [];
  @Input() defaultText: string = "Select Option";
  @Input() defaultValue: string = "";
  @Input() isDisabled: boolean = false;
  @Input() isLastPage: boolean = false;
  @Input() selectedItems: any[] = [];

  @Output() onItemSelect = new EventEmitter<any>();
  @Output() onSearchTermChange = new EventEmitter<string>();
  @Output() onListPageChange = new EventEmitter<boolean>();

  searchTerm: string = "";
  showDropdown: boolean = false;

  constructor(private eRef: ElementRef) {}

  @HostListener("document:click")
  onDocumentClick() {
    this.showDropdown = false;
  }

  ngOnInit(): void {}

  toggleDropdown(event: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    if (!this.isDisabled) {
      this.showDropdown = !this.showDropdown;
    }
  }

  selectItem(item: any) {
    this.onItemSelect.emit(item);
    // User requested to highlight instead of toggle closing
    // this.toggleDropdown();
  }

  onSearchChange(event: any) {
    this.onSearchTermChange.emit(event?.target.value);
  }

  isItemSelected(item: any): boolean {
    return this.selectedItems.some((i) => i._id === item._id);
  }

  onScroll(event: any) {
    if (
      event.target.offsetHeight + event.target.scrollTop + 1 >=
        event.target.scrollHeight &&
      !this.isLastPage
    ) {
      if (!this.loading) {
        this.loading = true;
        this.onListPageChange.emit(true);
      }
    }
  }

  // To handle loading state resets from parent
  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemList && !changes.itemList.firstChange) {
      this.loading = false;
    }
  }
}
